import { useRef, type FC } from "react";
import { DrawnSvg } from "@tennr/frontend/components/DrawnSvg";

interface AnimatedIcon5Props {
  className?: string;
  width?: number | string;
  height?: number | string;
}

export const AnimatedIcon5: FC<AnimatedIcon5Props> = ({ className, width = 40, height = 46 }) => {
  const ref = useRef<HTMLDivElement>(null!);

  return (
    <div ref={ref} className={className}>
      <DrawnSvg
        svgPath="/svg/5.svg"
        width={width}
        height={height}
        duration={1.2}
        delay={0.4} // Fifth icon with an even longer delay
        stroke="#BB6257"
        strokeWidth={1.75}
      />
    </div>
  );
};
